// Override global Date si DEBUG_DATE est défini (avant tout autre code)
import { installFakeDate } from '@shared/clock.js'

// En dev/staging, localStorage a priorité (modifiable à chaud via /debug)
if (import.meta.env.MODE !== 'production' || import.meta.env.VITE_IS_STAGING === 'true') {
  const stored = localStorage.getItem('debug_date')
  if (stored) {
    installFakeDate(stored)
  } else if (__DEBUG_DATE__) {
    installFakeDate(__DEBUG_DATE__)
  }
} else {
  installFakeDate(__DEBUG_DATE__)
}

import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'
import { usePostHog } from './composables/usePostHog.js'
import { Toaster } from 'vue-sonner'
import { installerGardeDepotFichier } from './utils/garde-depot-fichier.js'
import 'vue-sonner/style.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'overlayscrollbars/overlayscrollbars.css'
import './style.css'

// Initialize PostHog for session replay and error tracking
const { captureException } = usePostHog()

const app = createApp(App)

// Configure global error handler for Vue to capture errors in PostHog
app.config.errorHandler = (err, instance, info) => {
  // Capture Vue component errors in PostHog
  captureException(err, {
    error_type: 'Vue Error',
    vue_component_info: info,
    vue_instance: instance?.$?.type?.name || 'Unknown',
    component_name: instance?.$?.type?.__name || 'Unknown',
    vue_error_handler: true
  })

  // Log to console in development
  if (process.env.NODE_ENV === 'development') {
    console.error('Vue Error:', err, info)
  }
}

// Capture all uncaught JavaScript errors
window.onerror = (message, source, lineno, colno, error) => {
  // Capture JavaScript errors in PostHog with full context for source map resolution
  const errorObj = error || new Error(message)

  // Preserve original error properties for source map resolution
  if (errorObj) {
    errorObj.source = source
    errorObj.lineno = lineno
    errorObj.colno = colno
  }

  captureException(errorObj, {
    error_type: 'Uncaught JavaScript Error',
    error_message: message,
    error_source: source,
    error_line: lineno,
    error_column: colno,
    window_onerror: true
  })

  if (process.env.NODE_ENV === 'development') {
    console.error('Uncaught JavaScript Error:', message, source, lineno, colno, error)
  }

  // Return false to allow default error handling (console, etc.)
  return false
}

// Capture unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  captureException(event.reason, {
    error_type: 'Unhandled Promise Rejection',
    promise_rejection: true
  })

  if (process.env.NODE_ENV === 'development') {
    console.error('Unhandled Promise Rejection:', event.reason)
  }
})

// Staging mode: add .is-staging class to <html> for CSS overrides
if (import.meta.env.VITE_IS_STAGING === 'true') {
  document.documentElement.classList.add('is-staging')
}

app.use(router)
app.component('Toaster', Toaster)
installerGardeDepotFichier()

app.mount('#app')
